/* eslint-disable @typescript-eslint/no-var-requires */

if ($hasDep('ably', '2')) {
  throw new Error('useAblyChannel is not available when ably@2 is installed. Please migrate to the new Ably API (#ably-v3-upgrade).');
}
export const useAblyChannel = require('./compat/useAblyChannel').useAblyChannel;